import React, { useEffect, useState } from "react";
import axios from "react-axios";
import { getTrack } from "~/api/getTrack";

const useTrackData = (trackId) => {
    const [track, setTrack] = useState(null);
    const [loading, setLoading] = useState(true);
    const [failure, setFailure] = useState(false);

    useEffect(() => {
        if (!trackId) {
            setLoading(false);
            return;
        }

        setLoading(true);
        setFailure(false);

        // Original fetching logic implemented here
        getTrack(axios, trackId).then((data) => {
            const { data: trackObj = {} } = data;

            if (trackObj.id) {
                setTrack(trackObj);
                setLoading(false);
            } else {
                // Sets failure if no track ID is present in the response object
                setFailure(true);
                setLoading(false);
                setTrack(null);
            }
        }).catch(error => {
            // Handles network errors or promise rejections
            console.error("Track fetching failed:", error);
            setFailure(true);
            setLoading(false);
            setTrack(null);
        });

    }, [trackId, getTrack]); // Re-run effect when trackId changes

    return { track, loading, failure };
};

export { useTrackData }